/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { entity } from '@gh/core-data';

export const careerEnquiriesMapper = entity<any>({
// jobs: arrayOf(subentity<any>({
//   startDate: date(DateFormat.DateTime),
//   endDate: date(DateFormat.DateTime),
// })),
});
